import { Switch as SwitchPrimitive } from '@base-ui/react/switch';

import { cn } from '@/lib/utils';

export type SwitchProps = SwitchPrimitive.Root.Props & {
  size?: 'small' | 'medium';
};

const Switch = ({ className, size = 'medium', ...props }: SwitchProps) => {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size === 'medium' ? 'default' : 'sm'}
      className={cn(
        'peer group/switch relative inline-flex shrink-0 items-center rounded-full transition-all',
        'border border-transparent inset-shadow-sm/8 outline-none',
        'after:absolute after:-inset-x-3 after:-inset-y-2',
        'cursor-pointer',

        // sizes
        'data-[size=default]:h-[18.4px] data-[size=default]:w-8',
        'data-[size=sm]:h-4 data-[size=sm]:w-8',

        // unchecked
        'data-unchecked:bg-gray-300',

        // checked
        'data-checked:bg-green-400',

        // interactions
        'focus-visible:border-gray-500 focus-visible:ring-1 focus-visible:ring-gray-500',
        'hover:data-checked:bg-green-500 hover:data-unchecked:bg-gray-500',

        // invalid
        'aria-invalid:border-red-400 aria-invalid:bg-red-100 aria-invalid:ring-1 aria-invalid:ring-red-200/40',
        'aria-invalid:hover:bg-red-200 aria-invalid:focus-visible:ring-3',

        // disabled
        'data-disabled:cursor-not-allowed data-disabled:bg-gray-300!',

        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'pointer-events-none block rounded-full bg-gray-800 ring-0 transition-transform',
          'group-aria-invalid/switch:bg-red-400',

          // sizes
          'group-data-[size=default]/switch:size-3 group-data-[size=default]/switch:data-checked:translate-x-4 group-data-[size=default]/switch:data-unchecked:translate-x-0.5',
          'group-data-[size=sm]/switch:size-2.5 group-data-[size=sm]/switch:data-checked:translate-x-4.5 group-data-[size=sm]/switch:data-unchecked:translate-x-0.5',

          'data-disabled:bg-gray-500!',
        )}
      />
    </SwitchPrimitive.Root>
  );
};

export default Switch;
